<template>
  <div class="confirmation-modal">
    <el-dialog
      :before-close="beforeClose"
      center
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      :show-close="true"
      :visible="visible"
    >
      <div class="confirmation-modal__content">
        <svg-icon :icon="icon" class="confirmation-modal__icon" />

        <p class="confirmation-modal__message">
          <strong>{{ message }}</strong>
        </p>
        <h2 class="confirmation-modal__title">{{ title }}</h2>

        <common-button primary @click="confirm">{{ confirmationActionLabel }}</common-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import SvgIcon from '@/components/SvgIcon';
import { CATERING_CONFIRMATION_INTENTIONS } from '@/constants';
import CommonButton from '@/components/common/CommonButton';

const SUCCESS_ICON = 'donut-success';
const ERROR_ICON = 'missing-food';
const CATERING_CONFIRM_MODAL_EVENT = 'toggleDisplay';
const I18N_BASE_KEY = 'catering.confirmationModal';

export default {
  name: 'ConfirmationModal',
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    /**
     * Must match one of the keys of the translations map
     * catering.ConfirmationModal[intention]
     */
    intention: {
      type: String,
      required: true,
      validator: (value) => !!CATERING_CONFIRMATION_INTENTIONS[value],
    },
    /**
     * This property is needed when the intention property is set to 'incorrectMealType'
     */
    mealType: {
      type: String,
      required: false,
    },
    userOffice: {
      type: Object,
      required: false,
    },
  },
  components: {
    SvgIcon,
    CommonButton,
  },
  computed: {
    icon() {
      const successIntention = 'success';

      return this.intention === successIntention ? SUCCESS_ICON : ERROR_ICON;
    },
    title() {
      const message = this.$i18n.t(`${I18N_BASE_KEY}.${this.intention}.title`);

      return message;
    },
    message() {
      let message = this.$i18n.t(`${I18N_BASE_KEY}.${this.intention}.message`, {
        mealType: this.mealType,
      });
      const wrongOfficeIntention = 'wrongOffice';

      if (this.intention === wrongOfficeIntention && this.userOffice) {
        message = this.$i18n.t(`${I18N_BASE_KEY}.${this.intention}.message`, {
          office: this.userOffice.name,
        });
      }

      return message;
    },
    confirmationActionLabel() {
      return this.$i18n.t(`${I18N_BASE_KEY}.${this.intention}.confirmationAction`);
    },
    displayDialog: {
      get: () => this.visible,
      set: (value) => value,
    },
  },
  methods: {
    beforeClose(done) {
      this.$emit(CATERING_CONFIRM_MODAL_EVENT);
      done();
    },
    confirm() {
      this.$emit(CATERING_CONFIRM_MODAL_EVENT, this.intention);
    },
  },
};
</script>

<style scoped lang="scss">
@import '../../scss/_variables.scss';

.confirmation-modal {
  &__icon {
    width: 120px;
  }

  &__message {
    font-size: 18px;
    margin: 16px 0 16px 0;
  }

  &__title {
    color: $dark-grey-color;
    font-size: 18px;
    margin: 16px 0 16px 0;
    text-align: center;
    word-break: normal;

    &::first-letter {
      text-transform: uppercase;
    }
  }

  &__content {
    text-align: center !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/catering/ConfirmationModal.vue